// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middle {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 30px;
}
.middle strong {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  opacity: 0.6;
  font-size: 14px;
  left: 0;
  right: 0;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 20px auto 0px;
  height: 15px;
  z-index: 1;
  background: rgba(59, 49, 43, 0.1607843137);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin: 15px;
}
.header .title {
  padding-bottom: 0px;
  text-align: center;
  font-size: 1.5em;
}

.score {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.125);
  margin-bottom: 15px;
  padding-bottom: 10px;
}
.score .mini-card {
  display: inline-block;
  height: 28.6px;
  width: 19.5px;
  margin: 0 5px;
  background: color;
  border-radius: 3px;
}
.score .mini-card.red {
  background: var(--red);
}
.score .mini-card.green {
  background: var(--green);
}
.score span {
  height: 16px;
  width: 16px;
  font-size: 24px;
  text-align: center;
}

.hit {
  display: block;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 15px;
  height: 15px;
  -webkit-transition: all 0.125s;
  transition: all 0.125s;
  margin: 9px;
  border-radius: 50%;
}
.hit.hit-red.hitted {
  background-color: #ffbfbf;
  -webkit-box-shadow: 0px 1px 13px 14px #b36666;
          box-shadow: 0px 1px 13px 14px #b36666;
}
.hit.hit-blue.hitted {
  background-color: #bfbfff;
  -webkit-box-shadow: 0px 1px 13px 14px #6666b3;
          box-shadow: 0px 1px 13px 14px #6666b3;
}
.hit.hit-green.hitted {
  background-color: #bfffe1;
  -webkit-box-shadow: 0px 1px 13px 14px #66b386;
          box-shadow: 0px 1px 13px 14px #66b386;
}

@media screen and (max-width: 720px) {
  .score {
    margin-top: 20px;
  }
  .middle {
    -webkit-box-orient: vertical;
    -webkit-box-direction: reverse;
        -ms-flex-direction: column-reverse;
            flex-direction: column-reverse;
    margin-bottom: 0;
  }
  .middle .cards {
    margin: 25px 0;
  }
  .middle strong {
    margin: 0 auto;
  }
  ul.cards-hand {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/table/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,4BAAA;EAAA,oBAAA;AACJ;;AAGA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,YAAA;AAAF;AAEE;EACE,mBAAA;EACA,kBAAA;EAEA,gBAAA;AADJ;;AAKA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,mDAAA;EACA,mBAAA;EACA,oBAAA;AAFF;AAIE;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAII;EACE,sBAAA;AAFN;AAKI;EACE,wBAAA;AAHN;AAOE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AALJ;;AASA;EACE,cAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EAAA,sBAAA;EACA,WAAA;EACA,kBAAA;AANF;AAQE;EACE,yBAAA;EACA,6CAAA;UAAA,qCAAA;AANJ;AASE;EACE,yBAAA;EACA,6CAAA;UAAA,qCAAA;AAPJ;AAUE;EACE,yBAAA;EACA,6CAAA;UAAA,qCAAA;AARJ;;AAYA;EACE;IACE,gBAAA;EATF;EAWA;IACE,4BAAA;IAAA,8BAAA;QAAA,kCAAA;YAAA,8BAAA;IACA,gBAAA;EATF;EAWE;IACE,cAAA;EATJ;EAYE;IACE,cAAA;EAVJ;EAcA;IACE,oBAAA;IAAA,oBAAA;IAAA,aAAA;IACA,wBAAA;QAAA,qBAAA;YAAA,uBAAA;IACA,mBAAA;QAAA,eAAA;EAZF;AACF","sourcesContent":[".middle {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n\n  strong {\n    position: relative;\n    display: flex;\n    opacity: 0.6;\n    font-size: 14px;\n    left: 0;\n    right: 0;\n    align-items: center;\n    justify-content: center;\n    margin: 20px auto 0px;\n    height: 15px;\n    z-index: 1;\n    background: #3b312b29;\n    transition: all 0.3s;\n  }\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin: 15px;\n\n  .title {\n    padding-bottom: 0px;\n    text-align: center;\n\n    font-size: 1.5em;\n  }\n}\n\n.score {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.125);\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n\n  .mini-card {\n    display: inline-block;\n    height: 28.6px;\n    width: 19.5px;\n    margin: 0 5px;\n    background: color;\n    border-radius: 3px;\n\n    &.red {\n      background: var(--red);\n    }\n\n    &.green {\n      background: var(--green);\n    }\n  }\n\n  span {\n    height: 16px;\n    width: 16px;\n    font-size: 24px;\n    text-align: center;\n  }\n}\n\n.hit {\n  display: block;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  width: 15px;\n  height: 15px;\n  transition: all 0.125s;\n  margin: 9px;\n  border-radius: 50%;\n\n  &.hit-red.hitted {\n    background-color: #ffbfbf;\n    box-shadow: 0px 1px 13px 14px #b36666;\n  }\n\n  &.hit-blue.hitted {\n    background-color: #bfbfff;\n    box-shadow: 0px 1px 13px 14px #6666b3;\n  }\n\n  &.hit-green.hitted {\n    background-color: #bfffe1;\n    box-shadow: 0px 1px 13px 14px #66b386;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .score {\n    margin-top: 20px;\n  }\n  .middle {\n    flex-direction: column-reverse;\n    margin-bottom: 0;\n\n    .cards {\n      margin: 25px 0;\n    }\n\n    strong {\n      margin: 0 auto;\n    }\n  }\n\n  ul.cards-hand {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
